/**
 * @module events/types/touchMove
 */

/**
 * @type {string}
 */
export default 'touchmove'
